import { cva } from 'class-variance-authority';

export const progressbarVariants = 'flex w-full items-center gap-1';

export const progressbarStepClasses = cva(
  ['h-0-5 flex-1 rounded-lg transition-all duration-500 ease-in-out'],
  {
    variants: {
      state: {
        completed: 'bg-charcoal-500',
        current: 'bg-charcoal-100',
        next: 'bg-charcoal-50'
      }
    },
    defaultVariants: {
      state: 'next'
    }
  }
);
